import React, {useEffect, useState} from 'react';
import localStrings from "../../../localStrings";
import PageWithTitle from "../../../components/pages/pageWithTitle";
import ListProducts from "./list";
import Results from "./Results";

function Products() {
  return (
      <PageWithTitle title={localStrings.products}>
          <Results/>
      </PageWithTitle>
  )
}

export default Products